import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=1ed74b44&scoped=true"
import script from "./AppError.vue?vue&type=script&lang=ts"
export * from "./AppError.vue?vue&type=script&lang=ts"
import style0 from "./AppError.vue?vue&type=style&index=0&id=1ed74b44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed74b44",
  null
  
)

export default component.exports